import React, { useEffect, useState } from "react";
import { styled } from "@mui/system";
import Box from "@mui/material/Box";
import shopUploadIcon from "../../assets/shop-upload-icon.svg";
import { useDispatch } from "react-redux";
import { showToast } from "../../store/slices/common";
import { UploadRounded } from "@mui/icons-material";
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import { validateFileExtension } from "../../utils";
import { CircularProgress } from "@mui/material";

const FlexContainer = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
});

const Circle = styled(Box)(() => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  position: "relative",
  backgroundColor: "transparent",
  borderRadius: "12px",
  border: `1px solid #0832DE`,
}));

const CurvedCorner = styled(Box)(() => ({
  position: "absolute",
  bottom: "15px",
  borderRadius: "10px",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  background: "#FFFFFF",
  zIndex: 1,
  cursor: "pointer",
}));

const UploadImage = ({ image, onChange, style, id, disabled, name, onDelete }) => {
  const dispatch = useDispatch();

  const [preview, setPreview] = useState();
  const [loading, setLoading] = useState(false);

  const handleFileUpload = (event) => {
    setPreview(image);

    const file = event?.target?.files && event?.target?.files[0];

    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (validateFileExtension(file?.name, name)) {
          // setPreview(reader.result);
          Upload(file);
          // setOpen(true);
        } else {
          dispatch(
            showToast({ color: "error", msg: "Please Upload Valid imgs" })
          );
        }
      };
      reader.readAsDataURL(file);
    }
  };

  const Upload = async (file) => {
    setLoading(true);
    onChange(file);
    setLoading(false);
  };
  const handleFileDelete = () => {
    onDelete()
    const fileInput = document.getElementById(id);
    if (fileInput) {
      fileInput.value = null;
    }
  }

  useEffect(() => {
    setPreview(image);
  }, [image]);

  return (
    <>
      <FlexContainer
        sx={{ justifyContent: "flex-start" }}
        margin="8px 0 20px 0"
      >
        <Circle
          className={"uploadimgcircle"}
          sx={{
            width: style?.width || "200px",
            height: style?.height || "200px",
          }}
        >
          {preview ? (
            <img
              src={preview}
              alt=""
              style={{
                width: "100%",
                height: "100%",
                margin: "0.1rem",
                borderRadius: "12px",
                objectFit: "fill",
              }}
            />
          ) : (
            <>
              {loading ? (
                <CircularProgress size={40} />
              ) : (
                <img
                  alt=""
                  src={shopUploadIcon}
                  style={{
                    width: "50px",
                    height: "50px",
                    objectFit: "fill",
                  }}
                />
              )}
            </>
          )}
          <CurvedCorner
            sx={{
              right: style?.iconRight || "-25px",
              width: style?.iconWidth || "50px",
              height: style?.iconHeight || "50px",
              border: disabled ? "2px solid #6a6a6a" : "2px solid #0832DE",
            }}
          >
            <input
              type="file"
              id={id}
              style={{ display: "none" }}
              onChange={handleFileUpload}
              accept="image/*"
              disabled={preview ? true : false}
            />
            <label
              htmlFor={id}
              style={{ display: "flex", alignItems: "center" }}
            >
              {preview ? <DeleteOutlineIcon
                style={{
                  cursor: "pointer",
                  color: "#0832DE",
                  fontSize: "26px"
                }}
                onClick={handleFileDelete}
              /> : <UploadRounded
                style={{
                  cursor: "pointer",
                  color: disabled ? "#6a6a6a" : "#0832DE",
                }}
              />}
            </label>
          </CurvedCorner>
        </Circle>
      </FlexContainer>
    </>
  );
};

export default UploadImage;
